<template>
  <CommonModal>
    <template slot="header">
      <h3>Add Product Type</h3>
    </template>
    <template slot="body">
      <div>
        <table class="write_tbl">
          <tbody>
            <tr>
              <th>이름</th>
              <td>
                <input
                  type="text"
                  name="doctypeName"
                  class="form-control"
                  v-model="form.productVO.prodName"
                  v-validate="'required'"
                />
              </td>
            </tr>
            <tr>
              <th>설명</th>
              <td colspan="2">
                <textarea
                  class="form-control"
                  name="doctypeDesc"
                  v-model="form.productVO.prodDesc"
                ></textarea>
              </td>
            </tr>
            <tr>
              <th>사용여부</th>
              <td>
                <label
                  ><input
                    type="radio"
                    name="useYn"
                    v-model="form.productVO.useYn"
                    value="Y"
                  />
                  Use</label
                >
                <label
                  ><input
                    type="radio"
                    name="useYn"
                    v-model="form.productVO.useYn"
                    value="N"
                  />
                  Unused</label
                >
              </td>
            </tr>
          </tbody>
        </table>

        <!-- <table class="write_tbl" v-for="(item, index) in form.languages" :key="index">
          <tbody>
            <tr>
              <th>언어</th>
              <td>
                {{ item.language.codeName }}
              </td>
            </tr>
            <tr>
              <th>이름</th>
              <td>
                <input
                  type="text"
                  name="doctypeName"
                  class="form-control"
                  v-model="item.name"
                  v-validate="item.language.codeId == 'en' ? 'required' : ''"
                />
              </td>
            </tr>
            <tr>
              <th>설명</th>
              <td colspan="2">
                <textarea
                  class="form-control"
                  name="doctypeDesc"
                  v-model="item.desc"
                ></textarea>
              </td>
            </tr>
          </tbody>
        </table> -->
      </div>
    </template>
    <template slot="footer">
      <slot name="footer"> </slot>
    </template>
  </CommonModal>
</template>

<script>
import CommonModal from "@/components/modal/CommonModal";
import {
  fetchProdtypeForm,
  addProdType,
  checkProdTypeNameDuplication,
} from "@/api/prodtype";

export default {
  components: {
    CommonModal,
  },
  data() {
    return {
      form: {
        productVO: {
          prodId: "",
          prodName: "",
          prodDesc: "",
          useYn: "",
        },

        languages: [],
      },
      product: "",
    };
  },
  methods: {
    async save() {
      const validForm = await this.$validator.validateAll();
      if (validForm) {
        //prodTypeName 중복확인
        const { data } = await checkProdTypeNameDuplication(this.form);
        this.product = data.product;
        if (this.product == null || this.product == "" || this.product.length == 0) {
          try {
            const response = await addProdType(this.form);
            return response.data.status;
            // if (response.data.status) {
            //   this.reset();
            // }
          } catch (error) {
            console.log(error);
          }
        } else {
          return "alert.alreadyExist";
          // alert(this.$t("alert.alreadyExist"));
        }
      } else {
        return "alert.plzCheckAllValues";
        // alert(this.$t("alert.plzCheckAllValues"));
      }
    },
    reset() {
      this.form.productVO.prodId = "";
      this.form.productVO.prodName = "";
      this.form.productVO.prodDesc = "";
      this.form.productVO.useYn = "Y";
    },
    async fetchProdTypeForm(upperId, level) {
      const response = await fetchProdtypeForm(upperId, level);
      console.log(response);
      this.form = response.data;
      this.form.productVO.useYn = "Y";
    },
  },
};
</script>

<style></style>
